import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { usePOSSummary } from "@faire/retailer-visitor-shared/features/PointOfSale/hooks/usePOSSummary";
import { logPOSError } from "@faire/retailer-visitor-shared/features/PointOfSale/utils/logPOSError";
import { useIsNativeWebView } from "@faire/retailer-visitor-shared/hooks/nativeWebView/useIsNativeWebView";
import { ConnectCTASection } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/ConnectCTASection";
import { ConnectHeroSection } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/ConnectHeroSection";
import { ErrorModal } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/ErrorModal";
import { FAQSectionV2 } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/FAQSectionV2";
import { FlexibleSettingsSection } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/FlexibleSettingsSection";
import { HowItWorksSection } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/HowItWorksSection";
import { InventoryLevelsSection } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/InventoryLevelsSection";
import { LandingPageContext } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/LandingPageContext";
import { POSTestimonialSection, POSTestimonialType } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/POSTestimonialSection";
import { SaveTimeSection } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/SaveTimeSection";
import { StickyCTABanner } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/components/StickyCTABanner";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useQueryParams } from "@faire/web--source/ui/hooks/useQueryParams";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { QueryParameters as POSQueryParams } from "@faire/web-api--source/routes/point-of-sale";
import posOnboarding from "@faire/web-api--source/routes/point-of-sale/onboarding";
import React, { useContext, useEffect } from "react";
import { Redirect } from "react-router-dom";
export var POSLandingPage = function(param) {
    var isAboutPage = param.isAboutPage;
    var failed = useQueryParams(POSQueryParams.parse).failed;
    var isLinked = usePOSSummary().isLinked;
    var isMobile = useViewport().isMobile;
    var isNativeWebView = useIsNativeWebView();
    var viewEvent = useContext(LandingPageContext).viewEvent;
    useEffect(function() {
        viewEvent === null || viewEvent === void 0 ? void 0 : viewEvent();
    }, [
        viewEvent
    ]);
    useEffect(function() {
        if (failed) {
            logPOSError(new Error("POS connection callback returned with failure."), "oauth callback");
        }
    }, [
        failed
    ]);
    if (isLinked && !isAboutPage) {
        return /*#__PURE__*/ _jsx(Redirect, {
            to: posOnboarding()
        });
    }
    if (isMobile) {
        return /*#__PURE__*/ _jsxs(Column, {
            children: [
                /*#__PURE__*/ _jsx(ConnectHeroSection, {}),
                /*#__PURE__*/ _jsx(SaveTimeSection, {}),
                /*#__PURE__*/ _jsx(FlexibleSettingsSection, {}),
                /*#__PURE__*/ _jsx(InventoryLevelsSection, {}),
                /*#__PURE__*/ _jsx(POSTestimonialSection, {
                    testimonialTypes: [
                        POSTestimonialType.SAVE_TIME,
                        POSTestimonialType.FLEXIBLE_SETTINGS
                    ],
                    backgroundColor: Core.surface.inverse
                }),
                /*#__PURE__*/ _jsx(HowItWorksSection, {}),
                /*#__PURE__*/ _jsx(FAQSectionV2, {}),
                isNativeWebView ? /*#__PURE__*/ _jsx(Spacer, {
                    height: "4x"
                }) : /*#__PURE__*/ _jsx(Footer, {}),
                /*#__PURE__*/ _jsx(StickyCTABanner, {}),
                failed ? /*#__PURE__*/ _jsx(ErrorModal, {}) : null
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(StickyCTABanner, {}),
            /*#__PURE__*/ _jsx(ConnectHeroSection, {}),
            /*#__PURE__*/ _jsx(SaveTimeSection, {}),
            /*#__PURE__*/ _jsx(POSTestimonialSection, {
                testimonialTypes: [
                    POSTestimonialType.SAVE_TIME
                ],
                backgroundColor: Core.surface.subdued
            }),
            /*#__PURE__*/ _jsx(FlexibleSettingsSection, {}),
            /*#__PURE__*/ _jsx(POSTestimonialSection, {
                testimonialTypes: [
                    POSTestimonialType.FLEXIBLE_SETTINGS
                ],
                backgroundColor: Core.surface.inverse
            }),
            /*#__PURE__*/ _jsx(InventoryLevelsSection, {}),
            /*#__PURE__*/ _jsx(ConnectCTASection, {}),
            /*#__PURE__*/ _jsx(HowItWorksSection, {}),
            /*#__PURE__*/ _jsx(FAQSectionV2, {}),
            /*#__PURE__*/ _jsx(Footer, {}),
            failed ? /*#__PURE__*/ _jsx(ErrorModal, {}) : null
        ]
    });
};
